import React from 'react';

import classNames from 'classnames';

import { Usp } from '../Usp/Usp';
import styles from './HeroUsp.module.css';

export type Props = {
  className?: string;
  heroUsp: string | null;
};

export const HeroUsp = React.memo((props: Props) => {
  const {
    heroUsp,
    className,
  } = props;

  const wrapperClass = classNames(
    styles.uspWrapper,
    className,
  );

  return heroUsp ? (
    <div className={wrapperClass}>
      <Usp
        uspClassName={styles.uspItem}
        iconClassName={styles.uspItemIcon}
        iconColor='var(--top-block-font-color)'
      >
        {heroUsp}
      </Usp>
    </div>
  ) : null;
});

HeroUsp.displayName = 'HeroUsp';
